var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLeftArrowDisabledWhite = function SvgLeftArrowDisabledWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.306 14.615 16.922 20l5.384 5.384"
  }))));
};

export { SvgLeftArrowDisabledWhite as ReactComponent };
export default __webpack_public_path__ + "8e4f30d886c2aef227ca09c727b37e71.svg";